import { useState } from 'react'

import { useQuery } from '@tanstack/react-query'

import { LiveEndpointKeys, LiveService } from 'common/services/live'
import {
  useTransmissionContext,
  useTransmissionDataContext
} from 'modules/transmission/context'
import {
  PlaybackStatus,
  Status,
  Transmission
} from 'modules/transmission/types'

export const useLiveRequestWithRetry = () => {
  const { code, visibility } = useTransmissionDataContext()
  const { setTransmissionData, transmissionData } = useTransmissionContext()
  const [refetchInterval, setRefetchInterval] = useState(10000)

  const { status, data, error, isFetching, isLoading, refetch } = useQuery({
    queryKey: [LiveEndpointKeys.getLive, code, visibility],
    queryFn: async (): Promise<Transmission> => {
      const response = await LiveService.getLive(code, visibility)

      // eslint-disable-next-line max-len
      setTransmissionData({
        ...transmissionData,
        status: response.status,
        playbackStatus: response.playbackStatus
      })

      return response
    },
    refetchInterval,
    onSuccess: data => {
      if (
        data.status === Status.COMPLETED
        && data.playbackStatus === PlaybackStatus.DOWNLOAD_AVAILABLE
      ) {
        setRefetchInterval(0)
      }
    }
  })

  return { status, data, error, isFetching, isLoading, refetch }
}
